import React, { useState, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import '../../../gcsp/styles/styles.css';
import { MotifTextLink, MotifTooltip } from '@ey-xd/motif-react';
import {
  GCSPHeadTable,
  TableData1C,
  TableData3DotStyle,
} from '../../../../atoms/gcsp/gcspTable.styles';
import TableHeader from '../../../../molecules/dcsp/components/tableHeader';
import { columnDefsKeys } from './columnDefs';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import { LicenseManager } from 'ag-grid-enterprise';
import { useMemo } from 'react';
import {
  getGCSProllingOpportunities,
  getGcspOpportunitiesDue,
} from '../../../../../services/gcspServices';
import { AG_GRID_LICENSE_KEY } from '../../../../../constants/licenseKeys';
import { useRecoilState, useRecoilValue } from 'recoil';
import {
  Gcsp_Opp_View_State,
  Gcsp_Comment_Modal_State,
  Current_User,
  Active_Tab_Gcsp,
  Gcsp_Opps_Details_Modal_State,
  System_Date_Time_State,
  All_Month_Data_State,
  Next_Button_Active_State,
} from '../../../../../recoil/recoil';
import { formatAWDDate, formateTOV, trimAndAddDots } from '../../../../../util/commonUtil';
import GcspCommentModal from '../../../../organisms/modals/gcspCommentModal';
import GcspOpportunityNameModal from '../../../../organisms/modals/gcspOpportunityNameModal';
import chat_outline from '../../../../assets/icons/chat_outline.png';
import GcspTableData from './gcspTableData';

LicenseManager.setLicenseKey(AG_GRID_LICENSE_KEY);

let gridApi;
let GcspOppsIframeUrl;
let CommentIframeUrl;

const GcspTable = () => {
  const isFirstColumn = params => {
    const displayedColumns = params.columnApi.getAllDisplayedColumns();
    const thisIsFirstColumn = displayedColumns[0] === params.column;
    return thisIsFirstColumn;
  };
  const [rowData, setRowData] = useState([]);
  const [columnDefs, setColumnDefs] = useState(columnDefsKeys);
  const [gcspOppViewData, setGcspOppViewData] = useRecoilState(Gcsp_Opp_View_State);
  const currentUser = useRecoilValue(Current_User);
  const [tabActive, setTabActive] = useRecoilState(Active_Tab_Gcsp);
  const [showGcspIframeModalRecoil, setGcspIframeModalRecoil] = useRecoilState(
    Gcsp_Opps_Details_Modal_State,
  );
  const systemDateTime = useRecoilValue(System_Date_Time_State);
  const [showCommentIframeModalRecoil, setCommentIframeModalRecoil] =
    useRecoilState(Gcsp_Comment_Modal_State);
  const [allMonthData, setAllMonthData] = useRecoilState(All_Month_Data_State);
  const [nextButtonActive, setNextButtonActive] = useRecoilState(Next_Button_Active_State);
  const [showNowRowsToShowText, setShowNowRowsToShowText] = useState(true);

  let newData = {};
  useEffect(() => {
    setRowData([]);
    setShowNowRowsToShowText(true);

    const fetchData = async () => {
      try {
        const opportunitiesDueAPI = await getGcspOpportunitiesDue(
          currentUser.email,
          systemDateTime,
        );

        const GCSPID = currentUser.email;
        const ACCOUNTID = currentUser.account_id;
        const YEAR = opportunitiesDueAPI.fiscal_year;
        const TYPE = 'rolling';
        const CURRENT_MONTH = opportunitiesDueAPI.month;

        const QUARTER = opportunitiesDueAPI.quarter;

        let START_DATE, END_DATE, MONTH;

        if (tabActive == '0') {
          START_DATE = opportunitiesDueAPI.current_month_start_date;
          END_DATE = opportunitiesDueAPI.current_month_end_date;
          MONTH = opportunitiesDueAPI.month;
        } else if (tabActive == '1') {
          START_DATE = opportunitiesDueAPI.next_month_start_date;
          END_DATE = opportunitiesDueAPI.next_month_end_dt_date;
          MONTH = opportunitiesDueAPI.next_month;
        } else {
          START_DATE = opportunitiesDueAPI.next2next_month_start_date;
          END_DATE = opportunitiesDueAPI.next2next_month_end_date;
          MONTH = opportunitiesDueAPI.next2next_month;
        }

        let getOpportunitiesDetailsAPI = await getGCSProllingOpportunities(
          GCSPID,
          ACCOUNTID,
          MONTH,
          YEAR,
          TYPE,
          START_DATE,
          END_DATE,
          CURRENT_MONTH,
          currentUser.email,
        );

        setShowNowRowsToShowText(false);

        newData = {
          ...getOpportunitiesDetailsAPI,
          Your_Judge: getOpportunitiesDetailsAPI['Your_Judge'].map(obj => ({
            ...obj,
            month: MONTH,
            quarter: QUARTER,
            year: YEAR,
          })),
        };
        if (newData.length !== 0) {
          setNextButtonActive(true);
        }

        if (
          newData.length !== 0 &&
          allMonthData[tabActive].Total_Forecasted === null &&
          allMonthData[tabActive].Your_Judge === null &&
          allMonthData[tabActive].Total_Commit === null
        ) {
          let recoilAllMonthData = { ...allMonthData };
          recoilAllMonthData[tabActive] = newData;
          setAllMonthData(recoilAllMonthData);
        }

        setGcspOppViewData(newData);

        const rowDataCommitted = getOpportunitiesDetailsAPI.Committed.map(data => ({
          ...data,
          background: '#ffffff',
        }));
        const rowDataNotCommitted = getOpportunitiesDetailsAPI.Not_Committed.map(data => ({
          ...data,
          background: '#f6f6fa',
        }));
        const rowDataMissed = getOpportunitiesDetailsAPI.Missed.map(data => ({
          ...data,
          background: '#f6f6fa',
        }));
        const opppData = rowDataCommitted.concat(rowDataNotCommitted, rowDataMissed);

        setRowData(opppData);
        if (opppData.length !== 0) {
          expandCommit();
        }
      } catch (error) {
        console.error('Error:', error);
      }
    };

    fetchData();
  }, [tabActive]);

  const handleGridReady = params => {
    ({ api: gridApi } = params);
  };

  const TextCellRendererC = ({ value }) => <TableData1C>{value}</TableData1C>;
  TextCellRendererC.propTypes = {
    value: PropTypes.string.isRequired,
  };

  const probCellRenderer = ({ value }) => {
    if (value === '' || value === null) {
      return <TableData1C style={{ margin: 10 }}>0</TableData1C>;
    }
    return <TableData1C style={{ margin: 10 }}>{value}</TableData1C>;
  };
  TextCellRendererC.propTypes = {
    value: PropTypes.string.isRequired,
  };

  // const probCellRenderer = ({ value }) => {
  //   if (value === '' || value === null) {
  //     return <TableData1C style={{ margin: 10 }}>0</TableData1C>;
  //   }
  //   return <TableData1C style={{ margin: 10 }}>{value}</TableData1C>;
  // };
  // TextCellRendererC.propTypes = {
  //   value: PropTypes.string.isRequired
  // };

  const AWD_Field_Rendere = ({ value }) => {
    if (value) {
      const awd = formatAWDDate(value);
      return <TableData1C style={{ margin: 10 }}>{awd}</TableData1C>;
    }
    return <TableData1C style={{ margin: 10 }}>{}</TableData1C>;
  };
  AWD_Field_Rendere.propTypes = {
    value: PropTypes.string.isRequired,
  };

  const onOpportunityNameClick = id => {
    GcspOppsIframeUrl = `${process.env.REACT_APP_OPPS_NAME_IFRAME_URL}/main.aspx?appid=${process.env.REACT_APP_OPP_NAME_URL_APP_ID}&navbar=off&forceUCI=1&pagetype=entityrecord&etn=opportunity&id=${id}&formid=${process.env.REACT_APP_OPP_NAME_URL_FORM_ID}`;
    setGcspIframeModalRecoil(true);
  };

  const onCommentIconClick = id => {
    CommentIframeUrl = `${process.env.REACT_APP_OPPS_NAME_IFRAME_URL}/main.aspx?appid=${process.env.REACT_APP_OPP_NAME_URL_APP_ID}&navbar=off&forceUCI=1&pagetype=entityrecord&etn=opportunity&id=${id}&formid=${process.env.REACT_APP_COMMENT_URL_FORM_ID}`;
    setCommentIframeModalRecoil(true);
  };

  const handleCommitLink = opportunityId => {
    onCommentIconClick(opportunityId);
  };

  const CommentColumnRenderer = ({ node, data }) => {
    if (node.group === true) {
      return <></>;
    }
    return (
      <TableData1C style={{ margin: 10 }}>
        <div style={{ marginLeft: 20 }}>
          <MotifTextLink
            variant="alt"
            href="#"
            onClick={() => handleCommitLink(data.opportunityId)}
          >
            <img src={chat_outline} alt="Comment link" className="CustomChatIcon" />
          </MotifTextLink>
        </div>
      </TableData1C>
    );
  };

  const TextLinkRenderer = ({ value, data, node }) => {
    if (node.group === true) {
      return <></>;
    }

    return (
      <div style={{ alignSelf: 'center', display: 'flex', alignItems: 'center' }}>
        <TableData1C style={{ margin: 10 }}>
          <MotifTextLink
            variant="alt"
            href="#"
            onClick={() => {
              onOpportunityNameClick(data.opportunityId);
            }}
          >
            <MotifTooltip
              id="bottom"
              trigger={trimAndAddDots(value)}
              allowHover={true}
              allowClick={true}
              placement="bottom"
            >
              {value}
            </MotifTooltip>
          </MotifTextLink>
        </TableData1C>
      </div>
    );
  };

  const CommitColumnRenderer = ({ value }) => {
    let dynamicBackgroundColor = '#168736';

    if (value === 'Not Committed') {
      dynamicBackgroundColor = '#C4C4CD';
      value = 'No Commit';
    } else if (value === 'Missed') {
      dynamicBackgroundColor = '#ED6500';
      value = 'Missed';
    } else {
      value = 'Commit';
    }

    return (
      <TableData1C>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <TableData3DotStyle backgroundColor={dynamicBackgroundColor} />
          <div style={{ flex: 1, margin: 10 }}>{value}</div>
        </div>
      </TableData1C>
    );
  };

  const ServiceLineCelRenderer = ({ value }) => {
    return <TableData1C style={{ margin: 10 }}>{formateTOV(value)}</TableData1C>;
  };
  ServiceLineCelRenderer.propTypes = {
    value: PropTypes.string.isRequired,
  };

  const EmptyCelRenderer = ({ value, data }) => {
    if (data) {
      if (data.category === 'Missed') {
        return <TableData1C style={{ margin: 10 }}>{}</TableData1C>;
      }
    }
    return <TableData1C style={{ margin: 10 }}>{value}</TableData1C>;
  };
  ServiceLineCelRenderer.propTypes = {
    value: PropTypes.string.isRequired,
    data: PropTypes.string.isRequired,
  };

  const getRowStyle = params => {
    if (params.node.key == 'Committed' || params.node.parent.key == 'Committed') {
      // For row groups
      return { background: '#ffffff' };
    } else {
      // For inner elements
      return { background: '#eaeaf2' };
    }
  };

  const autoGroupColumnDef = useMemo(() => {
    return {
      headerName: 'PL Commit Status',
      // minWidth: 300,
      cellRendererParams: {
        suppressCount: true,
        innerRenderer: 'commitColumnRenderer',
      },
      suppressMenu: true,
      suppressMovable: true,
    };
  }, []);

  const groupIncludeFooter = params => {
    const node = params.node;
    if (node && node.level === 1) return true;
    if (node && node.key === 'France') return true;
    return false;
  };

  const groupRowRenderer = params => {
    return params.node.group
      ? `Custom Group: ${params.node.key}`
      : params.data[params.colDef.field];
  };

  const gridRef = useRef();

  const expandCommit = useCallback(() => {
    clearTimeout();
    setTimeout(() => {
      if (!!gridRef.current.api) {
        gridRef.current.api.forEachNode(node => {
          if (node.key === 'Committed') {
            if (node.expanded === true) {
            } else {
              gridRef.current.api.setRowNodeExpanded(node, true, true);
            }
          }
        });
      }
    }, 100);
  }, []);

  return (
    <>
      <GCSPHeadTable className="ag-theme-alpine " id="gcspheadtable">
        <AgGridReact
          ref={gridRef}
          firstColumnBorderRight
          columnDefs={columnDefs}
          rowData={rowData}
          groupDisplayType={'singleColumn'}
          groupRowRenderer={groupRowRenderer}
          showOpenedGroup={true}
          suppressHorizontalScroll={true}
          autoGroupColumnDef={autoGroupColumnDef}
          onGridReady={handleGridReady}
          headerHeight={70}
          headerCellWidth={200}
          // overlayLoadingTemplate={
          //   '<span aria-live="polite" aria-atomic="true" style="padding: 10px; solid #666; background: #fffff">Data Is Loading...</span>'
          // }
          // overlayNoRowsTemplate={
          //   '<span aria-live="polite" aria-atomic="true" style="padding: 10px; solid #666; background: #fffff">No Rows To Show</span>'
          // }
          components={{
            agColumnHeader: TableHeader,
            textCellRendererC: TextCellRendererC,
            textLinkRenderer: TextLinkRenderer,
            commentColumnRenderer: CommentColumnRenderer,
            commitColumnRenderer: CommitColumnRenderer,
            awd_Field_Rendere: AWD_Field_Rendere,
            serviceLineCelRenderer: ServiceLineCelRenderer,
            emptyCelRenderer: EmptyCelRenderer,
            probCellRenderer: probCellRenderer,
          }}
          getRowStyle={getRowStyle}
          alwaysShowVerticalScroll={true}
          overlayNoRowsTemplate={showNowRowsToShowText ? 'Loading...' : 'No Rows To Show'}
        />
        {showGcspIframeModalRecoil && <GcspOpportunityNameModal urlSource={GcspOppsIframeUrl} />}
        {showCommentIframeModalRecoil && <GcspCommentModal urlSource={CommentIframeUrl} />}
      </GCSPHeadTable>
      {gridRef.current !== undefined && <GcspTableData refValue={gridRef} />}
    </>
    // )
  );
};

export default GcspTable;
